<template>
  <section id="cases" class="section">
    <div class="container">
      <div class="section-header">
        <span class="section-header-title">Nice to meet you!</span>
        <div class="is-flex">
          <img class="avatar" src="@/assets/img/me.jpg" alt="Thomas Neuteboom"/>
          <h2 class="section-header-subtitle">My name is <a href="https://www.linkedin.com/in/thomas-neuteboom/">Thomas
            Neuteboom</a>, I'm a freelance mobile app developer. I collaborate with leading brands, create my own
            products from scratch and set up ventures with external partners. Here's where I showcase some of my work.
          </h2>
        </div>
      </div>
      <hr style="margin-bottom: 2rem;">
      <div class="columns is-multiline">
        <div class="column is-flex is-one-third">
          <div class="case">
            <div class="case-image-container tilt">
              <img class="case-image-portrait" src="@/assets/img/case_bibblebabble_portrait.jpg"/>
            </div>
            <p class="case-body">
              <tag value="iOS"/>
              <tag value="Back-end"/>
              <tag value="Start-up"/>
              <br/>
              <a href="https://www.bibblebabble.app" target="_blank">www.bibblebabble.app</a>
              <br/>
              <strong class="has-text-black">BibbleBabble!</strong> — Created an online multiplayer word game where poetry meets competition.
              <br/>
              <small class="has-text-black has-text-weight-semibold">October 2024 - present</small>

            </p>
          </div>
        </div>
        <div class="column is-flex is-one-third">
          <div class="case">
            <div class="case-image-container tilt">
              <img class="case-image-portrait" src="@/assets/img/case_coop_portrait.jpg"/>
            </div>
            <p class="case-body">
              <tag value="iOS"/>
              <tag value="Android"/>
              <br/>
              <a href="https://www.plus.nl" target="_blank">www.plus.nl</a>
              <br/>
              <strong class="has-text-black">Coop</strong> — Creating new app features for Coop, a
              popular grocery store in the Netherlands.
              <br/>
              <small class="has-text-black has-text-weight-semibold">October 2021 - March 2022</small>

            </p>
          </div>
        </div>
        <div class="column is-flex is-one-third">
          <div class="case">
            <div class="case-image-container tilt">
              <img class="case-image-portrait" src="@/assets/img/case_piggy_portrait.jpg"/>
            </div>
            <p class="case-body">
              <tag value="iOS"/>
              <tag value="Android"/>
              <tag value="From Scratch"/>
              <br/>
              <a href="https://www.piggy.eu" target="_blank">www.piggy.eu</a>
              <br/>
              <strong class="has-text-black">Piggy</strong> — App from scratch for Piggy with thousands of merchants and
              over 2.000.000 users.
              <br/>
              <small class="has-text-black has-text-weight-semibold">October 2019 - April 2021</small>
            </p>
          </div>
        </div>
        <div class="column is-flex is-one-third">
          <div class="case">
            <div class="case-image-container tilt">
              <img class="case-image-portrait" src="@/assets/img/case_homies_portrait.jpg"/>
            </div>
            <p class="case-body">
              <tag value="iOS"/>
              <tag value="Android"/>
              <br/>
              <a href="https://www.achmea.nl" target="_blank">www.achmea.nl</a>
              <br/>
              <strong class="has-text-black">Achmea</strong> — Created a mobile IoT self-installation alarm service for Achmea.
              <br/>
              <small class="has-text-black has-text-weight-medium">September 2018 - August 2019</small>
            </p>
          </div>
        </div>
        <div class="column is-flex is-two-thirds">
          <div class="case">
            <div class="case-image-container case-image-container-wide tilt">
              <img class="case-image-wide" src="@/assets/img/case_sundata_wide.jpg"/>
              <img class="case-image-portrait" src="@/assets/img/case_sundata_portrait.jpg"/>
            </div>
            <p class="case-body">
              <tag value="Website"/>
              <tag value="Front-end"/>
              <tag value="Back-end"/>
              <tag value="From Scratch"/>
              <br/>
              <a href="https://www.sundata.nl" target="_blank">www.sundata.nl</a>
              <br/>
              <strong class="has-text-black">Sundata</strong> — Software that turns solar data and local weather into human-readable insights using machine learning.
              <br/>
              <small class="has-text-black has-text-weight-medium">October 2018 - August 2019</small>
            </p>
          </div>
        </div>
        <div class="column is-flex is-one-third">
          <div class="case">
            <div class="case-image-container tilt">
              <img class="case-image-portrait" src="@/assets/img/case_chewpy_portrait.jpg"/>
            </div>
            <p class="case-body">
              <tag value="iOS"/>
              <tag value="Android"/>
              <tag value="From Scratch"/>
              <br/>
              <strong class="has-text-black">Chewpy</strong> — Discovering the best recipes using .
              <br/>
              <small class="has-text-black has-text-weight-medium">July 2018 - July 2019</small>
            </p>
          </div>
        </div>
        <div class="column is-flex is-one-third">
          <div class="case">
            <div class="case-image-container tilt">
              <img class="case-image-portrait" src="@/assets/img/case_moneymonk_portrait.jpg"/>
            </div>
            <p class="case-body">
              <tag value="iOS"/>
              <tag value="Android"/>
              <tag value="From Scratch"/>
              <br/>
              <a href="https://www.moneymonk.nl" target="_blank">www.moneymonk.nl</a>
              <br/>
              <strong class="has-text-black">MoneyMonk</strong> — Creating an all-in-one solution for entrepreneurs.
              <br/>
              <small class="has-text-black has-text-weight-medium">October 2015 - August 2025</small>
            </p>
          </div>
        </div>
        <div class="column is-flex is-one-third">
          <div class="case">
            <div class="case-image-container tilt">
              <img class="case-image-portrait" src="@/assets/img/case_stucomm_portrait.jpg"/>
            </div>
            <p class="case-body">
              <tag value="iOS"/>
              <tag value="Android"/>
              <tag value="From Scratch"/>
              <br/>
              <a href="https://www.stucomm.nl" target="_blank">www.stucomm.nl</a>
              <br/>
              <strong class="has-text-black">StuComm</strong> — A students-app from scratch for all universities in The Netherlands with more
              than 1.000.000 active users.
              <br/>
              <small class="has-text-black has-text-weight-medium">September 2014 - September 2015</small>
            </p>
          </div>
        </div>
      </div>
      <hr style="margin-bottom: -2rem;">
    </div>
  </section>
</template>

<script>
import Tilt from 'vanilla-tilt'
import Tag from '@/components/Tag'
import ScrollReveal from 'scrollreveal'

export default {
  name: 'CasesSection',
  components: {Tag},
  mounted () {
    this.$el.querySelectorAll('.tilt').forEach((element) => {
      Tilt.init(element, {max: 5, speed: 300})
    })

    ScrollReveal().reveal('#cases .section-header', {
      distance: '5%',
      origin: 'bottom',
      interval: 130,
      duration: 500,
      delay: 100,
    })

    ScrollReveal().reveal('#cases .case', {
      distance: '5%',
      origin: 'bottom',
      interval: 280,
      duration: 700,
      delay: 150,
    })
  }
}

</script>